import { useParams } from 'react-router-dom';

export const useTaskIdParam = () => {
  const { taskId } = useParams<{ taskId: string }>();

  if (!taskId)
    throw new Error(
      'useTaskIdParam can only be used whn the :taskId is present in the URL',
    );

  return taskId;
};
